import React from 'react'
import HeaderUpper from '../components/HeaderComponents/HeaderUpper'
import Header from '../components/HeaderComponents/Header'
import FooterSection from '../components/FooterSection/Footer'
import FaqSection from '../components/FaqSection/FaqSection'
import CtaSection from '../components/CtaSection/CtaSection'
import TabSwitchSection from '../components/TabSwitchSection/TabSwitchSection'
import MidSection from '../components/MidSection/MidSection'
import CompanyPartner from '../components/CompanySection/CompanyPartner'
import ThreeCardSection from '../components/ThreeCardSection/ThreeCard'
import ThreeImageTextSection from '../components/ThreeImageSection/Threeimage'
import Question from '../components/QuestionAnswer/Question'
import UseCasesSection from '../components/UseCaseSection/UseCaseSection'
import MidBannerSection from '../components/MidBanner/MidBannerSection'
import AgentTabSwitchSection from '../components/FourtabSwitch/Fourtabswtich'
import PillarsSection from '../components/OverviewSection/Overviewsection'
import BannerSection from '../components/BannerSection/Banner'
import InfoBoxes from '../components/InfoSection/InfoSection'

export default function AgentSre() {
    return (
        <>
        <HeaderUpper/>
        <Header/>
        <BannerSection/>
        <InfoBoxes/>
        <CompanyPartner/>
        <PillarsSection/>
        <MidSection/>
        <AgentTabSwitchSection/>
        <MidBannerSection/>
        <ThreeCardSection/>
        <ThreeImageTextSection/>
        <UseCasesSection/>
        <Question/>
        <TabSwitchSection/>
        <FaqSection/>
        <CtaSection/>
        <FooterSection/>
        </>
    )

}